import * as React from "react";
const SvgFiRrSort = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sort_svg__a)">
      <path
        fill="#062147"
        d="M18.873 11.021H5.127a2.126 2.126 0 0 1-1.568-3.56L10.046.872a2.67 2.67 0 0 1 3.939.034l6.43 6.528a2.126 2.126 0 0 1-1.542 3.587M5.01 8.837a.12.12 0 0 0 0 .11.11.11 0 0 0 .114.074h13.748a.11.11 0 0 0 .114-.075.11.11 0 0 0-.022-.135l-6.437-6.535A.7.7 0 0 0 12 2.021a.66.66 0 0 0-.5.221L5.01 8.838M12 24.011a2.67 2.67 0 0 1-1.985-.887L3.584 16.6a2.125 2.125 0 0 1 1.543-3.586h13.746a2.125 2.125 0 0 1 1.568 3.558l-6.487 6.59a2.64 2.64 0 0 1-1.954.85m-6.873-9a.13.13 0 0 0-.114.075.13.13 0 0 0 .022.134l6.437 6.534a.7.7 0 0 0 .528.257.67.67 0 0 0 .5-.223l6.493-6.6a.11.11 0 0 0 0-.108.11.11 0 0 0-.114-.074z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sort_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSort;
